import React from "react";

export const CloseIcon = (props) => {
  return (
    <svg viewBox="0 0 10 10" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4141 5.00001L9.7071 1.70701C10.0981 1.31601 10.0981 0.684006 9.7071 0.293006C9.3161 -0.0979941 8.6841 -0.0979941 8.2931 0.293006L5.0001 3.58601L1.7071 0.293006C1.3161 -0.0979941 0.684097 -0.0979941 0.293097 0.293006C-0.0979026 0.684006 -0.0979026 1.31601 0.293097 1.70701L3.5861 5.00001L0.293097 8.29301C-0.0979026 8.68401 -0.0979026 9.31601 0.293097 9.70701C0.488097 9.90201 0.744097 10 1.0001 10C1.2561 10 1.5121 9.90201 1.7071 9.70701L5.0001 6.41401L8.2931 9.70701C8.4881 9.90201 8.7441 10 9.0001 10C9.2561 10 9.5121 9.90201 9.7071 9.70701C10.0981 9.31601 10.0981 8.68401 9.7071 8.29301L6.4141 5.00001Z"
        fill={!!props.fill ? props.fill : "#686868"}
      />
    </svg>
  );
};
